export const searchIndex = [
  {
    title: "Beranda",
    description: "Halaman utama Forum Indonesia Muda",
    url: "/",
    category: "Halaman",
    icon: "🏠",
    keywords: ["home", "beranda", "utama"],
  },
  {
    title: "Tentang FIM",
    description: "Sejarah, visi misi, dan nilai-nilai FIM",
    url: "/tentang",
    category: "Halaman",
    icon: "ℹ️",
    keywords: ["about", "tentang", "sejarah", "visi", "misi"],
  },
  {
    title: "Regional FIM",
    description: "60+ cabang regional FIM di seluruh Indonesia",
    url: "/tentang/regional",
    category: "Tentang",
    icon: "📍",
    keywords: ["regional", "cabang", "daerah", "wilayah"],
  },
  {
    title: "FIM Club",
    description: "21 komunitas alumni berdasarkan minat",
    url: "/tentang/fim-club",
    category: "Tentang",
    icon: "👥",
    keywords: ["club", "klub", "komunitas", "minat"],
  },
  {
    title: "Program Pelatihan FIM",
    description: "Program kaderisasi tahunan untuk pemimpin muda",
    url: "/program/pelatihan",
    category: "Program",
    icon: "🎓",
    keywords: ["pelatihan", "training", "kaderisasi", "pendaftaran", "daftar"],
  },
  {
    title: "Program Unggulan",
    description: "Program-program unggulan FIM",
    url: "/program/program-unggulan",
    category: "Program",
    icon: "⭐",
    keywords: ["unggulan", "program", "kegiatan"],
  },
  {
    title: "Cerita Alumni",
    description: "Kisah inspiratif dari alumni FIM",
    url: "/cerita-alumni",
    category: "Halaman",
    icon: "📖",
    keywords: ["alumni", "cerita", "kisah", "inspirasi", "testimoni"],
  },
  {
    title: "Blog & Berita",
    description: "Informasi terbaru seputar FIM",
    url: "/blog",
    category: "Halaman",
    icon: "📰",
    keywords: ["blog", "berita", "news", "artikel"],
  },
  {
    title: "FAQ",
    description: "Pertanyaan yang sering diajukan",
    url: "/faq",
    category: "Halaman",
    icon: "❓",
    keywords: ["faq", "pertanyaan", "tanya", "jawab", "bantuan"],
  },
  {
    title: "Gabung Relawan",
    description: "Bergabung menjadi relawan FIM",
    url: "/gabung-relawan",
    category: "Halaman",
    icon: "🤝",
    keywords: ["relawan", "volunteer", "gabung", "daftar"],
  },
  {
    title: "Donasi",
    description: "Dukung gerakan pemuda Indonesia",
    url: "/donasi",
    category: "Halaman",
    icon: "💝",
    keywords: ["donasi", "donate", "dukung", "bantuan"],
  },
];
